// CESAR AUGUSTO ARIAS
// 11/05/2018
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';

//services
import { ConfigService } from '../../servicios/config/config.service';
import {KeyService} from '../../servicios/key.service';

@Injectable()
export class ContactosService {
  _key= new KeyService();
  PATH = new ConfigService().obtenerPath();

  constructor(
    private http:Http
  ) {}

  //Obtener listado de contactos de un tercero
  getContactos(terceroid){
    let url = this.PATH+'/api/public/list-contactos/' + terceroid;
    return this.http.get(url,{headers:this._key.head()})
    .map(resp=>resp.json());
  }

  //Obtener contacto por id
  obtenerContacto(id){
    let url = this.PATH+'/api/public/contactos/'+id+'/edit';
    return this.http.get(url,{headers:this._key.head()})
    .map(resp=>resp.json());
  }

  /**
   * Permite obtener el listado de contactos de una sucursal especifica
   * JMM-2018-06-28
   */
  getContactosSucursal(sucursalid)
  {
    let url = this.PATH+'/api/public/list-contactos-sucursal/' + sucursalid;
    return this.http.get(url,{headers:this._key.head()}).map(resp=>resp.json());
  }// .getContactosSucursal(sucursalid)

  obtenerContactoTercero(terceroid = null,sucursalid = null){
    terceroid = terceroid ? terceroid : null;
    let url = this.PATH+'/api/public/obtenerContactoTercero/'+ terceroid +'/'+ sucursalid;
    return this.http.get(url,{headers:this._key.head()}).map(resp=>resp.json());
  }// .obtenerContactoTercero(sucursalid)

  obtenerContactosItemequipo(id){
    let url = this.PATH+'/api/public/obtenerContactosItemequipo';
    return this.http.post(url,id,{headers:this._key.head()}).map(resp=>resp.json());
  }

  busquedaContacto(cedula){
    let url = this.PATH+'/api/public/busquedaContacto/'+ cedula;
    return this.http.get(url,{headers:this._key.head()}).map(resp=>resp.json());
  }//.busquedaContacto(cedula)

  listContacto(){
    let url = this.PATH+'/api/public/contactos';
    return this.http.get(url,{headers:this._key.head()}).map(resp=>resp.json());
  }//.busquedaContacto(cedula)


}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/servicios/Terceros/contactos.service.ts